import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Toast } from '@shared/toast/models/toast';
import { ToastBuilder } from '@shared/toast/builders/toast.builder';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly showSource$ = new Subject<Toast>();

  constructor(private readonly builder: ToastBuilder) {}

  get show$(): Observable<Toast> {
    return this.showSource$.asObservable();
  }

  show(factory: (builder: ToastBuilder) => Toast): void {
    this.showSource$.next(factory(this.builder.newInstance()));
  }
}
